import { commonAPI } from '@redux/api/common.api'
import { URLS } from '@constants'
import { MobileListItem } from '@mobileTypes'

type GETMobileListItemsParams = {
  searchPattern?: string
  sort?: string
}

export const mobileListItemApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllMobileListItems: build.query<MobileListItem[], GETMobileListItemsParams | void>({
      query: params => ({
        url: URLS.MOBILE_CFG + '/list/list',
        params: {
          searchPattern: params?.searchPattern,
          sort: params?.sort,
        },
      }),
      providesTags: ['AllMobileListItems'],
    }),

    fetchMobileListItemById: build.query<MobileListItem, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/list/id/${id}`,
      }),
      providesTags: ['SingleMobileListItem'],
    }),

    createMobileListItem: build.mutation<
      MobileListItem,
      Omit<MobileListItem, 'id'>
    >({
      query: item => ({
        url: URLS.MOBILE_CFG + '/list',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileListItems'],
    }),

    updateMobileListItem: build.mutation<MobileListItem, MobileListItem>({
      query: item => ({
        url: URLS.MOBILE_CFG + '/list',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileListItems', 'SingleMobileListItem'],
    }),

    deleteMobileListItem: build.mutation<void, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/list/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllMobileListItems'],
    }),

    copyMobileListItem: build.mutation<MobileListItem, { id: string; title: string; internalId: string }>({
      query: body => ({
        url: URLS.MOBILE_CFG + '/list/copy',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AllMobileListItems'],
    }),
  }),
})

export const {
  useFetchAllMobileListItemsQuery,
  useFetchMobileListItemByIdQuery,
  useCreateMobileListItemMutation,
  useUpdateMobileListItemMutation,
  useDeleteMobileListItemMutation,
  useCopyMobileListItemMutation,
} = mobileListItemApi
